import React, { useEffect, useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import Toolbar from '../../../../components/toolbar/Toolbar';
import Button from '../../../../components/button/Button';
import { StateModel, StateModel_Admin } from '../../../../redux/store';
import { connect } from 'react-redux';
import {
  createAnzeigeStatus,
  deleteAnzeigeStatus,
  getAnzeigeStati,
  getFreieSendungsStati,
  getSendungsStati,
  updateSendungsStatus,
} from '../../../../redux/actions/admin';
import { Sendungsstatus } from '../../../../api';
import Modal from '../../../../components/modal/Modal';
import InputFieldText from '../../../../components/input/floating-label/input-field/InputFieldText';
import SliderCheckbox from '../../../../components/slidercheckbox/SliderCheckbox';
import IconPicker from '../../../dev/icon-picker/IconPicker';

interface AnzeigestatusProps {
  admin: StateModel_Admin;
  getAnzeigeStati: (search: string) => void;
  getSendungsStati: (id: number, search: string) => void;
  getFreieSendungsStati: (search: string) => void;
  createAnzeigeStatus: (value: Sendungsstatus) => void;
  deleteAnzeigeStatus: (value: number) => void;
  updateSendungsStatus: (
    value: Sendungsstatus,
    anzeigestatus: boolean,
    edit: boolean
  ) => void;
}

const Anzeigestatus = (props: AnzeigestatusProps) => {
  const emptyStatus: Sendungsstatus = {
    anzeige: false,
    awSperre: false,
    id: undefined,
    kurzBezeichnung: '',
    sdst_id_anzeige: undefined,
    anzeigefolge: undefined,
    icon: undefined,
  };

  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showAuswahlModal, setShowAuswahlModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [showIconModal, setShowIconModal] = useState(false);
  const [pickedIcon, setPickedIcon] = useState('');

  const [newOrEdit, setNewOrEdit] = useState('new');
  const [searchASString, setSearchASString] = useState('');
  const [searchSDGString, setSearchSDGString] = useState('');
  const [searchFSString, setSearchFSString] = useState('');
  const [currentSendungsstati, setCurrentSendungsStati] = useState<Array<any>>([
    {},
  ]);
  const [freieSendungsstati, setFreieSendungsstati] = useState<Array<any>>([
    {},
  ]);
  const [selectedAnzeigestatus, setSelectedAnzeigestatus] =
    useState<Sendungsstatus>(emptyStatus);
  const [selectedSendungsstatus, setSelectedSendungsstatus] =
    useState<number>(-1);
  const [selectedStatus, setSelectedStatus] = useState<number>(-1);
  const [newAnzeigeStatus, setNewAnzeigeStatus] =
    useState<Sendungsstatus>(emptyStatus);
  const [isDefault, setDefault] = useState(false);

  useEffect(() => {
    props.getSendungsStati(selectedAnzeigestatus.id ?? -1, searchASString);
    props.getFreieSendungsStati(searchFSString);
  }, [props.admin.reloadSendungsStati]);

  useEffect(() => {
    const newCurrentSendungsstati = [...props.admin.currentSendungsStati];
    setCurrentSendungsStati(newCurrentSendungsstati);
  }, [props.admin.currentSendungsStati]);

  useEffect(() => {
    const newFreieSendungsstati = [...props.admin.freieSendungsStati];
    setFreieSendungsstati(newFreieSendungsstati);
    const ncs = [...props.admin.currentSendungsStati];
    setCurrentSendungsStati(ncs);
  }, [props.admin.freieSendungsStati]);

  useEffect(() => {
    props.getAnzeigeStati(searchASString);
  }, [searchASString]);

  useEffect(() => {
    props.getSendungsStati(selectedAnzeigestatus.id ?? -1, searchSDGString);
  }, [searchSDGString]);

  useEffect(() => {
    props.getFreieSendungsStati(searchFSString);
  }, [searchFSString]);

  const ladeSendungsstati = (status: Sendungsstatus) => {
    setSelectedAnzeigestatus(status);
    setDefault(!!status.defaultstatus);
    setNewAnzeigeStatus({
      ...newAnzeigeStatus,
      kurzBezeichnung: status.kurzBezeichnung?.trim(),
      anzeigefolge: status.anzeigefolge,
      icon: status.icon,
    });
    setSelectedSendungsstatus(-1);
    props.getSendungsStati(status.id ?? -1, searchSDGString);
  };

  const isSelected = (id1: number | undefined, id2: number | undefined) => {
    return id1 === id2;
  };

  const handleClose = () => {
    setShowStatusModal(false);
    setShowAuswahlModal(false);
    setShowWarning(false);
  };

  const neuerAnzeigeStatus = () => {
    setNewOrEdit('new');
    setNewAnzeigeStatus(emptyStatus);
    setShowStatusModal(true);
  };

  const createAnzeigeStatus = (status: Sendungsstatus) => {
    const sdgstatus: Sendungsstatus = {
      kurzBezeichnung: status.kurzBezeichnung?.trim(),
      anzeige: true,
      awSperre: false,
      defaultstatus: isDefault,
      icon: status.icon,
      anzeigefolge: status.anzeigefolge,
    };
    props.createAnzeigeStatus(sdgstatus);
    setShowStatusModal(false);
  };

  const editAnzeigeStatus = () => {
    setNewOrEdit('edit');
    setShowStatusModal(true);
  };

  const updateAnzeigeStatus = (status: Sendungsstatus) => {
    const sdgstatus: Sendungsstatus = {
      id: selectedAnzeigestatus.id,
      kurzBezeichnung: status.kurzBezeichnung?.trim(),
      anzeige: true,
      awSperre: false,
      defaultstatus: isDefault,
      icon: status.icon,
      anzeigefolge: status.anzeigefolge,
    };
    props.updateSendungsStatus(sdgstatus, true, true);
    setShowStatusModal(false);
  };

  const removeAnzeigeStatus = (id: number) => {
    if (currentSendungsstati.length <= 0) {
      const sdgstati = props.admin.anzeigeStati.find(
        sdgstati => sdgstati.id === id
      );
      if (sdgstati) {
        props.deleteAnzeigeStatus(id);
      }
    } else {
      setShowWarning(true);
    }
  };

  const statusZuordnen = () => {
    props.getFreieSendungsStati(searchFSString);
    setShowAuswahlModal(true);
  };

  const statusEntordnen = (id: number) => {
    const newCurrentStati = [...props.admin.currentSendungsStati];
    const status = newCurrentStati.find(status => status.id === id);
    if (status) {
      status.sdst_id_anzeige = undefined;
      props.updateSendungsStatus(status, false, false);
    }
  };

  const insertStatusForAnzeigeStatus = (id: number) => {
    const newFreieStati = [...props.admin.freieSendungsStati];
    const status = newFreieStati.find(status => status.id === id);
    if (status) {
      status.sdst_id_anzeige = selectedAnzeigestatus.id;
      props.updateSendungsStatus(status, false, false);
    }
  };

  const chooseIcon = () => {
    setShowIconModal(true);
  };

  const anzeigestatiList = (as: Sendungsstatus) => {
    return (
      <li
        key={`as: ${as.id}`}
        className={`select-list-option ${
          isSelected(selectedAnzeigestatus.id ?? -1, as.id) && 'selected'
        }`}
        onClick={() => {
          ladeSendungsstati(as);
        }}
      >
        <div>
          <i className={as.icon} />
          {` ${as.kurzBezeichnung}`}
        </div>
      </li>
    );
  };

  const sendungsstatiList = (sst: Sendungsstatus) => {
    return (
      <li
        key={`sst: ${sst.id}`}
        className={`select-list-option ${
          isSelected(selectedSendungsstatus, sst.id) && 'selected'
        }`}
        onClick={() => {
          setSelectedSendungsstatus(sst.id ?? -1);
        }}
      >
        {sst.kurzBezeichnung}
      </li>
    );
  };

  const freieStatiList = (status: Sendungsstatus) => {
    return (
      <li
        key={`frei: ${status.id} ${status.kurzBezeichnung}`}
        className={`select-list-option ${
          isSelected(selectedStatus, status.id) && 'selected'
        }`}
        title={status.kurzBezeichnung}
        onClick={() => {
          setSelectedStatus(status.id ?? -1);
        }}
      >
        {status.kurzBezeichnung}
      </li>
    );
  };

  const handleIconClose = () => {
    const status: Sendungsstatus = selectedAnzeigestatus;
    status.icon = pickedIcon;
    props.updateSendungsStatus(status, true, true);
    setShowIconModal(false);
  };

  const anzeigefolgeComparator = (a: Sendungsstatus, b: Sendungsstatus) => {
    if (a.anzeigefolge && b.anzeigefolge) {
      if (a.anzeigefolge < b.anzeigefolge) {
        return -1;
      }
      if (a.anzeigefolge > b.anzeigefolge) {
        return 1;
      }
      return 0;
    }
    return 0;
  };

  return (
    <GridCellWrapper
      classes='anzeigestatus'
      label='Sendungsstatus Translator'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <div className='anzeigecontent'>
        <div className='anzeigestati'>
          &nbsp; Anzeigestatus
          <div className={'status-search-liste'}>
            <div className='listen'>
              <Toolbar>
                <div className='searchbar'>
                  <i className='fas fa-search fa-lg' />
                  <input
                    type='text'
                    placeholder={'...'}
                    id='search-input'
                    value={searchASString}
                    onChange={e => setSearchASString(e.target.value)}
                  />
                </div>
              </Toolbar>
              <ul>
                {props.admin.anzeigeStati
                  .sort(anzeigefolgeComparator)
                  .map(hm => {
                    return anzeigestatiList(hm);
                  })}
              </ul>
            </div>
            {/* + in der linken Tabelle*/}
            <div className='icons'>
              <Button
                tooltip='neuen Anzeigestatus anlegen'
                classes={'iconButton'}
                key={0}
                onClickHandler={() => {
                  neuerAnzeigeStatus();
                }}
              >
                <i className='fas fa-plus' />
              </Button>
              <br />
              {/* edit in der linken Tabelle*/}
              <Button
                tooltip='Anzeigestatus bearbeiten'
                classes={'iconButton'}
                key={1}
                onClickHandler={() => {
                  editAnzeigeStatus();
                }}
              >
                <i className='fas fa-pen'></i>
              </Button>
              <br />
              <Button
                tooltip='Anzeigestatus Icon'
                classes={'iconButton'}
                key={2}
                onClickHandler={() => {
                  chooseIcon();
                }}
              >
                <i className='fas fa-image'></i>
              </Button>
              <br />
              {/*- in der linken Tabelle*/}
              <Button
                tooltip='kein Anzeigestatus mehr'
                classes={'iconButton'}
                key={3}
                onClickHandler={() => {
                  removeAnzeigeStatus(selectedAnzeigestatus.id ?? -1);
                }}
                disabled={
                  selectedAnzeigestatus.id == 1000001 ||
                  selectedAnzeigestatus.id == 1000002
                }
              >
                <i className='fas fa-minus' />
              </Button>
            </div>
          </div>
        </div>
        <div className='sendungsstati'>
          &nbsp; Sendungsstatus
          <div className={'status-search-liste'}>
            <div className='listen'>
              <Toolbar>
                <div className='searchbar'>
                  <i className='fas fa-search fa-lg' />
                  <input
                    type='text'
                    placeholder={'...'}
                    id='search-input'
                    value={searchSDGString}
                    onChange={e => setSearchSDGString(e.target.value)}
                  />
                </div>
              </Toolbar>
              <ul>
                {currentSendungsstati.map(cm => {
                  return sendungsstatiList(cm);
                })}
              </ul>
            </div>
            {/* + in der rechten Tabelle*/}
            <div className='icons'>
              {!!(selectedAnzeigestatus.id ?? -1 > 0) && (
                <Button
                  tooltip='Sendungsstatus auswählen '
                  classes={'iconButton'}
                  key={3}
                  onClickHandler={() => {
                    statusZuordnen();
                  }}
                >
                  <i className='fas fa-plus' />
                </Button>
              )}
              <br />
              {/* - in der rechten Tabelle*/}
              {!!(selectedSendungsstatus > 0) && (
                <Button
                  tooltip='Sendungsstatus entfernen '
                  classes={'iconButton'}
                  key={4}
                  onClickHandler={() => {
                    statusEntordnen(selectedSendungsstatus);
                  }}
                >
                  <i className='fas fa-minus' />
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/*MODAL freie Sendungsstati auswählen */}

      <Modal
        show={showAuswahlModal}
        closeHandler={() => setShowAuswahlModal(false)}
        titel='Sendungsstatus auswählen'
      >
        <div className='modalliste'>
          <Toolbar>
            <div className='searchbar'>
              <i className='fas fa-search fa-lg' />
              <input
                type='text'
                placeholder={'...'}
                title={'Bitte einen Status auswählen'}
                id='search-input'
                value={searchFSString}
                onChange={e => setSearchFSString(e.target.value)}
              />
            </div>
          </Toolbar>
          <ul>
            {freieSendungsstati.map(fm => {
              return freieStatiList(fm);
            })}
          </ul>
        </div>
        <div className='modal-btn-group'>
          <button
            className='modal-btn'
            key={5}
            onClick={() => {
              insertStatusForAnzeigeStatus(selectedStatus);
            }}
          >
            Zuweisen
          </button>
          <button className='modal-btn' key={6} onClick={() => handleClose()}>
            Schlie&szlig;en
          </button>
        </div>
      </Modal>

      {/*MODAL Anzeigestatus bearbeiten */}

      <Modal
        show={showStatusModal}
        closeHandler={() => setShowStatusModal(false)}
        titel={
          !!(newOrEdit === 'new')
            ? 'neuer Anzeigestatus'
            : 'Anzeigstatus bearbeiten'
        }
      >
        <div className='statusModal'>
          <div className={'statusModal-inputFields'}>
            <InputFieldText
              label='Anzeigestatus'
              name='anzeigestatus'
              classes='txf_anzeigestatus'
              maxlength={35}
              value={newAnzeigeStatus.kurzBezeichnung}
              onChangeHandler={value =>
                setNewAnzeigeStatus({
                  ...newAnzeigeStatus,
                  kurzBezeichnung: value,
                })
              }
              required
              resetValue={''}
            />
            <p> Default Anzeigestatus?</p>
            <SliderCheckbox
              value={isDefault}
              onChangeHandler={setDefault}
              labelActive={<i className='far fa-eye' />}
              labelInactive={<i className='fas fa-eye-slash' />}
              tooltip={'Defaultanzeigestatus?'}
              disabled={false}
            />
          </div>
          <div className='modal-btn-group'>
            <button
              className='modal-btn'
              key={7}
              onClick={() => {
                newOrEdit === 'new'
                  ? createAnzeigeStatus(newAnzeigeStatus)
                  : updateAnzeigeStatus(newAnzeigeStatus);
              }}
            >
              OK
            </button>
            <button className='modal-btn' key={8} onClick={() => handleClose()}>
              Abbrechen
            </button>
          </div>
        </div>
      </Modal>

      {/*MODAL Warnung  */}

      <Modal
        show={showWarning}
        closeHandler={() => setShowWarning(false)}
        titel='Achtung'
      >
        <div className={'as-warning'}>
          Bitte entfernen Sie zuerst alle zugeordneten Sendungsstati.
        </div>
        <div className='modal-btn-group'>
          <button className='modal-btn' key={9} onClick={() => handleClose()}>
            OK
          </button>
        </div>
      </Modal>

      {/*MODAL Icon Picker  */}

      <Modal
        show={showIconModal}
        closeHandler={() => setShowIconModal(false)}
        titel='Icon auswählen'
      >
        <IconPicker setPickedIcon={setPickedIcon} />
        <div className='modal-btn-group'>
          <button
            className='modal-btn'
            key={6}
            onClick={() => handleIconClose()}
          >
            OK
          </button>
        </div>
      </Modal>
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  admin: state.Admin,
});

export default connect(mapStateToProps, {
  getAnzeigeStati,
  getSendungsStati,
  getFreieSendungsStati,
  createAnzeigeStatus,
  deleteAnzeigeStatus,
  updateSendungsStatus,
})(Anzeigestatus);
